"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackleLog = void 0;
var Hackle = require("@hackler/javascript-sdk");
var utils_1 = require("./utils");
var HackleLog = /** @class */ (function () {
    function HackleLog(hackle_key) {
        var _this = this;
        this.getHackleUserData = function () {
            var userId = (0, utils_1.getJSONfromUserInfoCookie)()._id;
            var defaultObj = {
                "id": (0, utils_1.getCookie)("device_id"),
                "deviceId": (0, utils_1.getCookie)("device_id"),
            };
            if (!userId.length) {
                return defaultObj;
            }
            return __assign(__assign({}, defaultObj), { userId: userId });
        };
        this.send = function (key, data) {
            if (data === void 0) { data = {}; }
            var event = { key: key, properties: data };
            var user = _this.getHackleUserData();
            _this._client.track(event, user);
        };
        this._client = Hackle.createInstance(hackle_key, {
            debug: false,
            auto_track_page_view: true
        });
    }
    return HackleLog;
}());
exports.HackleLog = HackleLog;
//# sourceMappingURL=hackle.js.map